import PropTypes from 'prop-types'
import { itemSourcePropType } from './item-source-prop-type'

/**
 * Proptype that represents an array of item sources
 * @typedef {Array.<itemSourcesPropType>}  itemSourcesPropType
 */
export const itemSourcesPropType = PropTypes.arrayOf(itemSourcePropType)
